
<template>
    <router-link id="btn" :to="this.route ? this.route : ''"
        :style="{ 'background-color': this.color, 'height': this.height, 'width': this.width, 'font-size': this.size }">
        {{
            this.text
        }}</router-link>
</template>
 
<script>
//此页为通用页头
export default {
    props: ['width', 'height', 'text', 'color', 'route', 'size'],
    data() {
        return {

        };
    },
    methods: {
    }
};
</script>
<style lang="scss" scoped>
#btn {
    min-width: 26px;
    height: 24px;
    font-family: MohrRounded Heavy, 'FZLanTYK_Black', Microsoft YaHei, sans-serif;
    color: #3f4141;
    font-size: 20px;
    text-align: center;
    background-color: #ffdd40;
    line-height: 29px;
    border-radius: 14px;
    padding: 11px 25px 13px;
    transition: all 0.25s ease;
    cursor: pointer;

    &:hover {
        background-color: #ffc640;
    }
}
</style>